// Generated by purs version 0.13.0
"use strict";
var Chip_Model_DieReason = require("../Chip.Model.DieReason/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var Alive = (function () {
    function Alive() {

    };
    Alive.value = new Alive();
    return Alive;
})();
var Dead = (function () {
    function Dead(value0) {
        this.value0 = value0;
    };
    Dead.create = function (value0) {
        return new Dead(value0);
    };
    return Dead;
})();
var Pause = (function () {
    function Pause() {

    };
    Pause.value = new Pause();
    return Pause;
})();
var Complete = (function () {
    function Complete() {

    };
    Complete.value = new Complete();
    return Complete;
})();
var eqState = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Init && y instanceof Init) {
            return true;
        };
        if (x instanceof Alive && y instanceof Alive) {
            return true;
        };
        if (x instanceof Dead && y instanceof Dead) {
            return Data_Eq.eq(Chip_Model_DieReason.eqDieReason)(x.value0)(y.value0);
        };
        if (x instanceof Pause && y instanceof Pause) {
            return true;
        };
        if (x instanceof Complete && y instanceof Complete) {
            return true;
        };
        return false;
    };
});
module.exports = {
    Init: Init,
    Alive: Alive,
    Dead: Dead,
    Pause: Pause,
    Complete: Complete,
    eqState: eqState
};
